import { useEffect, useRef } from 'react'

import { useGoogleMap } from '@react-google-maps/api'

const GROUP_Z_INDEX = 200000

type Props = {
    items: any[]
}

export default function GroupMarker(props: Props) {
    const map       = useGoogleMap()
    const itemsRef  = useRef(props.items)

    itemsRef.current = props.items

    // recreate google marker only when group members change, not on every parent render
    const signature = _.map(props.items, (item: any) => {
        return item.type + item.id
    }).join()

    useEffect(() => {
        if (!map) {
            return
        }

        const el = document.createElement('div')
        el.className    = 'group-marker'
        el.textContent  = String(props.items.length)

        const marker = new (window as any).google.maps.marker.AdvancedMarkerElement({
            position    : {
                lat : _.meanBy(props.items, 'lat'),
                lng : _.meanBy(props.items, 'lng')
            },
            map         : map,
            content     : el,
            zIndex      : GROUP_Z_INDEX,
            title       : _.map(props.items, 'name').join('\n'),
        })
        marker.addListener('gmp-click', () => {
            window.bus.triggerEvent("info-panel:hide")
            window.bus.triggerEvent("group:select", itemsRef.current)
            window.bus.triggerEvent("group-panel:show", itemsRef.current)
            return
        })

        return () => {
            marker.map = null
            return
        }
    }, [map, signature]) // eslint-disable-line react-hooks/exhaustive-deps

    return null
}
